<div
  *ngIf="loading"
  class="spinner"
  style="
    background-color: #fffbff;
    width: 100%;
    height: calc(100vh - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
  "
>
  <mat-spinner></mat-spinner>
</div>

<div
  style="background: #fffbff; overflow-x: hidden; padding-bottom: 4rem"
  [style.display]="loading ? 'none' : 'block'"
>
  <div class="row justify-content-center">
    <div style="background: #fffbff; width: 100%; max-width: 100%; padding: 0">
      <div
        class=""
        style="
          background: #5b43d9;
          width: 100%;
          border-bottom-left-radius: 40px;
          border-bottom-right-radius: 40px;
          margin-top: -1px;
        "
      >
        <header
          class="denounce-table-title"
          style="
            margin: 0 auto;
            max-width: 1300px;
            padding: 0;
            padding-top: 20px;
            padding-bottom: 15px;
          "
        >
          <h2 style="margin: 0 !important">
            {{ "RealTimeTitle" | translate }}
          </h2>
        </header>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div
      class="d-flex flex-row align-items-center justify-content-between"
      style="width: 65%; margin-top: 3rem"
    >
      <div
        class="list-section"
        style="
          width: calc(32% + 2rem);
          height: 39rem;
          background-color: white;
          border-radius: 1rem;
          padding: 1rem;
        "
      >
        <strong>
          {{ "RealTimeLastEmergencies" | translate }}
        </strong>

        <div class="last-ocurrence-list mt-4">
          <div
            *ngFor="let ocurrence of complaints"
            class="ocurrence"
            [routerLink]="'/home/ocurrences-details/' + ocurrence._id"
            id="ocurrence._id"
          >
            <div
              class="ocurrence-information"
              style="display: flex; flex-direction: column"
            >
              <div class="ocurrence-title" style="display: flex; gap: 10px">
                <p class="text-ocurrence">{{ ocurrence?._id }}</p>
                <img
                  src="assets/icons/bus.svg"
                  *ngIf="ocurrence.bus_number"
                  alt=""
                />
              </div>

              <div
                class="time-ocurrence"
                style="display: flex; margin-top: 3px"
              >
                <img src="assets/icons/clock.svg" alt="" />
                <p class="text-ocurrence-time">
                  {{ ocurrence.time_since_creation }}
                </p>
              </div>

              <div
                class="type-ocurrence"
                style="display: flex; gap: 10px; margin-top: 10px"
              >
                <span
                  *ngFor="let type of ocurrence.type.slice(0, 2)"
                  class="span-ocurrence-type"
                  >{{ type }}</span
                >

                <span
                  *ngIf="ocurrence.type.length > 2"
                  class="span-ocurrence-type"
                  >...</span
                >
              </div>
            </div>
            <div class="more-details">
              <img src="assets/icons/eye.svg" alt="mais detalhes" />
            </div>
          </div>
        </div>

        <button
          [routerLink]="'/home/real-time/emergencies'"
          class="see-all-ocurrences"
        >
          {{ "RealTimeSeeAllEmergencies" | translate }}

          <img src="assets/icons/go-icon.svg" alt="" />
        </button>
      </div>

      <div class="no-emergency" *ngIf="this.emergencies.length == 0">
        <p>
          {{ "RealTimeNoOcurrencesInTheLast15Minutes" | translate }}
        </p>
      </div>

      <div
        class="emergencies-section"
        [style.display]="this.emergencies.length == 0 ? 'none' : 'block'"
      >
        <strong>
          {{ "RealTimeRealTimeEmergencies" | translate }}
        </strong>

        <div class="emergencies-count">
          <img src="assets/icons/emergency.svg" alt="" />
          {{ "RealTimeReceivedEmergenciesCount1" | translate }}
          {{ this.emergencies.length }}
          {{ "RealTimeReceivedEmergenciesCount2" | translate }}
        </div>

        <div id="emergencies-map" style="flex: 70%; border-radius: 16px">
          <agm-map [latitude]="center.lat" [longitude]="center.lng" [zoom]="15">
            <agm-marker
              [iconUrl]="'./../../assets/images/pin.png'"
              [latitude]="center.lat"
              [longitude]="center.lng"
            ></agm-marker>
          </agm-map>
        </div>
      </div>
    </div>
  </div>
</div>
